<app-header></app-header>
<div class="wrapper">
  <ng-container *ngIf="isServerResponseCome === true">

      <div class="center_body">

          <div class="card">

              <ng-container *ngIf="paymentMessage.value == constants.STATUS_SUCCESS">
                  <h1>{{paymentMessage.text}}</h1>
              </ng-container>

              <ng-container *ngIf="paymentMessage.value == constants.STATUS_REJECTED">
                  <p>{{paymentMessage.text}}</p>
              </ng-container>

              <div class="flex_rows mt10 align-self">
                    <h6>List Of Application(s)</h6>
                    <div class="legends">
                      <span><i class="fa fa-eye" aria-hidden="true"></i> <p class="">View/Print Application |</p></span>
                      <span><i class="fa fa-refresh" aria-hidden="true"></i><p class="">Check Status of payment</p></span>
                    </div>
              </div>

              <table style="width: 100%;">
                  <thead>
                      <tr>
                          <th  style="width:17%;" data-label="applicationNo" nowrap scope ="row">Application no.</th>
                          <th  style="width:17%;" data-label="referenceNo" nowrap scope ="row">Reference no.</th>
                          <th  style="width:40%;" data-label="fullName" nowrap scope ="row">Full Name</th>
                          <th  style="width:15%;" data-label="paymentStatus" nowrap scope ="row">Payment Status</th>
                          <th  style="width:10%;" data-label="action" nowrap scope ="row">Action</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr *ngIf="paidApplicationsList?.length === 0">
                          <td colspan="5">No record found</td>
                      </tr>

                      <tr *ngFor="let paidApplication of paidApplicationsList;">
                          <td  data-label="application No" nowrap scope ="row"><span>{{paidApplication.applicationIdV1}}</span></td>
                          <td  data-label="reference No" nowrap scope ="row"><span>{{paidApplication.referenceIdV1}}</span></td>
                          <td  data-label="full Name" nowrap scope ="row"><span>{{paidApplication.fullName}}</span></td>
                          <td  data-label="payment Status" nowrap scope ="row"><span [ngClass]="paidApplication.paymentStatus === constants.STATUS_SUCCESS ? 'success' : 'danger'">{{paidApplication.paymentStatusLabel}}</span></td>
                          <td  data-label="action" nowrap scope ="row">
                              <span (click)="viewApplication(paidApplication.id)" tooltip="View" placement="bottom" style="margin-left: 10px; cursor: pointer;"><i class="fa fa-eye" aria-hidden="true"></i></span>
                              <span *ngIf="paidApplication.paymentStatus === constants.STATUS_INITIATE" (click)="checkPaymentStatus(paidApplication.id)" tooltip="Check Payment Status" placement="bottom" style="margin-left: 10px; cursor: pointer;"><i class="fa fa-refresh" aria-hidden="true"></i></span>
                          </td>
                      </tr>
                  </tbody>
              </table>

              <input type="button" (click)="openDashboard()" value="Go to Dashboard" class="save_btn">

          </div>

      </div>

  </ng-container>
</div>


<app-footer></app-footer>
